import React, { useContext } from 'react';
import _merge from 'lodash/merge';

import DefaultTheme from 'components/styles/themes/default-theme';

const ComponentsContext = React.createContext<any>({});

export interface ComponentsContextProviderProps {
  children: React.ReactNode;
  /** @ignore - used internally to pass theme context */
  themeContext?: React.Context<any>;
  /** @ignore - used internally to pass direction context */
  directionContext?: React.Context<{ RTL: boolean }>;
  /** @ignore - pass theme (object) */
  theme?: any;
  /** @ignore - pass direction (object) */
  direction?: { RTL?: boolean };
  /** @ignore - pass disableAnimation context */
  motionContext?: React.Context<{ disableAnimation: boolean }>;
  /** @ignore - pass disableAnimation */
  disableAnimation?: boolean;
}

const ComponentsContextProvider:React.FC<ComponentsContextProviderProps> = (props: ComponentsContextProviderProps) => {
  const {
    children,
    themeContext,
    directionContext,
    motionContext,
    disableAnimation,
    theme,
    direction
  } = props;

  const {
    RTL
  } = direction === undefined ? useContext(directionContext) : direction;
  let contextdisableAnimation = false;
  if (motionContext !== undefined) {
    const mContext = useContext(motionContext);
    // eslint-disable-next-line prefer-destructuring
    contextdisableAnimation = mContext.disableAnimation;
  }

  return (
    <>
      <ComponentsContext.Provider
        value={{
          theme: _merge({}, DefaultTheme, theme, themeContext ? useContext(themeContext) : {}),
          RTL,
          disableAnimation: disableAnimation || contextdisableAnimation,
        }}
      >
        {children}
      </ComponentsContext.Provider>
    </>
  );
};
ComponentsContextProvider.defaultProps = {
  themeContext: undefined,
  directionContext: undefined,
  motionContext: undefined,
  direction: undefined,
  disableAnimation: undefined,
  theme: {}
};
ComponentsContextProvider.displayName = 'ComponentsContextProvider';
export { ComponentsContextProvider, ComponentsContext };
